---
import { mergeComponents, PortableText } from 'astro-portabletext';
import { Block, List, ListItem } from 'astro-portabletext/components';
import type { PortableTextProps } from 'astro-portabletext/types';
import EmbedVideoSerializer from './EmbedVideoSerializer.astro';
import GenericLinkSerializer from './GenericLinkSerializer.astro';
import WebsiteInternalLinkSerializer from './WebsiteInternalLinkSerializer.astro';

export type Props = Pick<PortableTextProps, 'value' | 'components'>;

const { value, components: overrideComponents = {} } = Astro.props;

const components = mergeComponents(
  {
    mark: {
      genericLink: GenericLinkSerializer,
      websiteInternalLink: WebsiteInternalLinkSerializer,
    },
    type: {
      'hp-website-video': EmbedVideoSerializer,
    },
    block: Block,
    list: List,
    listItem: ListItem,
  },
  overrideComponents,
);
---

<PortableText value={value} components={components} />
